import { ColumnEventParams, ColumnProps } from "primereact/column";
import { CSSProperties } from "react"
import { Index } from ".";

export enum SelectModes {
  single = "single",
  multiple = "multiple"
}
export enum OrderModes {
  multiple = "multiple",
  single = "single"
}

export interface IPagination {
  pageIndex: number;
  pageSize: number;
}

export interface IGridColumn {
  order: number;
  field: string;
  header: string;
  sortable?: boolean;
  body?: (row: any, col: any) => JSX.Element;
  export?: (row: any) => string | undefined;
  exportNewLineChar?: string;
  hideForExport?: boolean;
  filter?: boolean;
  filterPlaceholder?: string;
  filterElement?: JSX.Element;
  style?: CSSProperties;

  editorBody?: (col:ColumnProps) => React.ReactNode;
  onEditorSubmit?: (e: ColumnEventParams) => void;
  onEditorCancel?: (e: ColumnEventParams) => void;
}

export interface IGridCommand {
  icon?: string;
  label?: string;
  className?: string;
  tooltip?: string;
  style?: CSSProperties;
  onClick?: (e:any, grid?: Index) => void;
  hide?: (row: any) => boolean;
  disabled?: (row: any) => boolean;

  body?: () => JSX.Element;
}